export default "__VITE_ASSET__DhUN$s6J__"